<template>
	<div class="wrapper" :style="{ backgroundImage: 'url(\'' + grain + '\')' }">
		<div class="image" :style="{ backgroundImage: 'url(\'' + image + '\')' }"></div>
	</div>
</template>
​
<script>
	export default {
		props: ['image','animated'],
		data(){
			return {
				grain: require("../assets/grain.png")
			}
		}
	}
</script>

<style scoped>
	.wrapper{
		height: 100%;
		width: 100%;
		background-repeat: repeat;
	}

	.image, .grain{
		min-height: 320px;
		height: 100%;
		width: 100%;
		background-position: center;
		background-size: cover;
		opacity: 0.9;
	}
</style>


// WEBPACK FOOTER //
// src/components/GrainImg.vue